import React, { useState } from "react";
import UserData from "./UserData";
import { ToastContainer } from "react-toastify";
function Dashboard() {
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [areas, setAreas] = useState([]);
  const data = [];
  const [filteredOptions, setFilteredOptions] = useState([]);

  return (
    <>
      <UserData
        areas={areas}
        setAreas={setAreas}
        selectedAreas={selectedAreas}
        setSelectedAreas={setSelectedAreas}
        data={data}
        filteredOptions={filteredOptions}
        setFilteredOptions={setFilteredOptions}
      />

      <ToastContainer />
    </>
  );
}

export default Dashboard;
